import type { OrderRepeatIntervalEntityTypeV1 } from '@montugroup/data-collection';
import {
  orderRepeatIntervalEntitySchemaV1,
  trackSelfDescribingEventTypeSafe,
  uiOpenDetailEventSchemaV1,
} from '@montugroup/data-collection';

export const logOpenDispenseIntervalSection = (data: OrderRepeatIntervalEntityTypeV1) =>
  trackSelfDescribingEventTypeSafe({
    event: {
      schema: uiOpenDetailEventSchemaV1,
      data: {
        section_name: `Interval Time Section - Order ${data.orderCode}`,
      },
    },
    context: [
      {
        schema: orderRepeatIntervalEntitySchemaV1,
        data,
      },
    ],
  });
